import { PurchaseFlowStepKey, usePurchaseFlowUtilities } from 'components/pages/PurchaseFlow/_main/contexts'

import { DynamicFlowStep } from 'components/common/DynamicFlow'
import { FC } from 'react'
import { FloorPlanConfigStepController } from './FloorPlanConfigStep.controller'
import { FloorPlanTemplatesProvider } from './FloorPlanTemplates.context'
import { useFloorPlanConfig } from '.'

/**
 * @component
 * Page in PurchaseFlow step for configuring floor plans.
 * 
 * @example 
 * <FloorPlanConfigStep />
 */
export const FloorPlanConfigStep: FC = () => {

  const { isFloorPlanConfigStepValid } = usePurchaseFlowUtilities()
  const { is3DAllowed } = useFloorPlanConfig()

  return (
    <DynamicFlowStep
      stepKey={PurchaseFlowStepKey.FLOOR_PLAN_CONFIG}
      isValid={isFloorPlanConfigStepValid}
    >
      <FloorPlanTemplatesProvider allow3D={is3DAllowed}>
        <FloorPlanConfigStepController />
      </FloorPlanTemplatesProvider>
    </DynamicFlowStep>
  )
}
